import { Address, getAddress } from "viem"

export type MerklReward = {
  id: string
  vault: Address
  apr: number
  startTimestamp: number
  endTimestamp: number
  type: "euler_lend" | "euler_borrow" | "euler_borrow_collateral"
  tokenPrice: number
  collateral?: Address
  amount: string
}

export function isActiveReward(
  reward: MerklReward,
  currentTime: number,
): boolean {
  return (
    reward.startTimestamp <= currentTime && reward.endTimestamp >= currentTime
  )
}

export function calculateTotalRewardApy(
  vault: Address,
  rewardsData?: Map<Address, { apy: number }[]>,
  merklData?: Record<Address, MerklReward[]>,
): number {
  const currentTime = Math.floor(Date.now() / 1000)
  let totalRewardApy = 0

  const rewardInfo = rewardsData?.get(getAddress(vault)) ?? []
  totalRewardApy += rewardInfo.reduce((sum, { apy }) => sum + apy, 0)

  const merklInfo = merklData?.[vault] ?? []
  totalRewardApy += merklInfo.reduce((sum, reward) => {
    if (reward.type === "euler_lend" && isActiveReward(reward, currentTime)) {
      return sum + reward.apr
    }
    return sum
  }, 0)

  return totalRewardApy
}

export function calculateTotalBorrowRewardApy(
  vault: Address,
  merklData?: Record<Address, MerklReward[]>,
  collaterals?: Address[],
): number {
  const currentTime = Math.floor(Date.now() / 1000)
  let totalRewardApy = 0

  const merklInfo = merklData?.[vault] ?? []
  totalRewardApy += merklInfo.reduce((sum, reward) => {
    if (isActiveReward(reward, currentTime)) {
      if (reward.type === "euler_borrow") {
        return sum + reward.apr
      } else if (
        reward.type === "euler_borrow_collateral" &&
        reward.collateral &&
        collaterals?.includes(reward.collateral)
      ) {
        return sum + reward.apr
      }
    }
    return sum
  }, 0)

  return totalRewardApy
}
